var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1850_3022",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1850_3022)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 17.25C12.2129 17.25 12.391 17.1781 12.5346 17.0343C12.6782 16.8906 12.75 16.7125 12.75 16.5V12.25C12.75 12.0375 12.6781 11.8594 12.5343 11.7156C12.3904 11.5719 12.2122 11.5 11.9997 11.5C11.7871 11.5 11.609 11.5719 11.4654 11.7156C11.3218 11.8594 11.25 12.0375 11.25 12.25V16.5C11.25 16.7125 11.3219 16.8906 11.4657 17.0343C11.6095 17.1781 11.7877 17.25 12.0003 17.25ZM12 9.78845C12.2288 9.78845 12.4207 9.71105 12.5755 9.55625C12.7303 9.40145 12.8077 9.20963 12.8077 8.98078C12.8077 8.75194 12.7303 8.56012 12.5755 8.4053C12.4207 8.2505 12.2288 8.1731 12 8.1731C11.7711 8.1731 11.5793 8.2505 11.4245 8.4053C11.2697 8.56012 11.1923 8.75194 11.1923 8.98078C11.1923 9.20963 11.2697 9.40145 11.4245 9.55625C11.5793 9.71105 11.7711 9.78845 12 9.78845ZM12.0016 22C10.6877 22 9.45268 21.7506 8.29655 21.252C7.1404 20.7533 6.13472 20.0765 5.2795 19.2217C4.42427 18.3669 3.74721 17.3616 3.24833 16.206C2.74944 15.0504 2.5 13.8156 2.5 12.5017C2.5 11.1877 2.74933 9.95268 3.248 8.79655C3.74667 7.6404 4.42342 6.63472 5.27825 5.7795C6.1331 4.92427 7.13834 4.24721 8.29398 3.74833C9.44959 3.24944 10.6844 3 11.9983 3C13.3122 3 14.5473 3.24933 15.7034 3.748C16.8596 4.24667 17.8652 4.92342 18.7205 5.77825C19.5757 6.6331 20.2527 7.63834 20.7516 8.79398C21.2505 9.94959 21.5 11.1844 21.5 12.4983C21.5 13.8122 21.2506 15.0473 20.752 16.2034C20.2533 17.3596 19.5765 18.3652 18.7217 19.2205C17.8669 20.0757 16.8616 20.7527 15.706 21.2516C14.5504 21.7505 13.3156 22 12.0016 22ZM12 20.5C14.2333 20.5 16.125 19.725 17.675 18.175C19.225 16.625 20 14.7333 20 12.5C20 10.2666 19.225 8.37498 17.675 6.82498C16.125 5.27498 14.2333 4.49998 12 4.49998C9.76664 4.49998 7.87498 5.27498 6.32498 6.82498C4.77498 8.37498 3.99998 10.2666 3.99998 12.5C3.99998 14.7333 4.77498 16.625 6.32498 18.175C7.87498 19.725 9.76664 20.5 12 20.5Z",
    fill: "#CED4DA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.cd5efebd4050700e8b76f300483f4ff6.svg";
export { ForwardRef as ReactComponent };